import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionOperationsOption } from '../keys/permissionOperations';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionOperations: PermissionOption[] = [
  {
    code: 'P433',
    option: PermissionOperationsOption.DASHBOARD_COMMON_LOGIN,
    permissions: ['dashboards.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P434',
    option: PermissionOperationsOption.DASHBOARD_LIST,
    permissions: ['dashboards.manage.list'],
    comparator: ComparatorEnum.CONTAINS,
  },
  {
    code: 'P435',
    option: PermissionOperationsOption.DASHBOARD_EDIT_SERVICE,
    permissions: ['dashboards.services.edit'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P436',
    option: PermissionOperationsOption.DASHBOARD_CANCEL_SERVICE,
    permissions: ['dashboards.services.cancel'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P437',
    option: PermissionOperationsOption.DASHBOARD_VIEW_EVIDENCE_SERVICE,
    permissions: ['dashboards.services.view_evidence'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P438',
    option: PermissionOperationsOption.DASHBOARD_VIEW_GPS,
    permissions: ['dashboards.services.view_fake_gps'],
    comparator: ComparatorEnum.EXACT,
  },
];